import React, { useEffect, useState } from "react";
import config from "../../config/config";
import { Link, useNavigate, useParams } from "react-router-dom";
import Web3 from "web3";

import {
  Container,
  Row,
  Col,
  Button,
  Modal,
} from "react-bootstrap";
import { Fade } from "react-reveal";
import "../../component/nftdetail.css";
import {
  getDataForNftDetailsAction,
  UserProfile,
} from "../../Action/user.action";
import Cookies from "js-cookie";
import toast, { Toaster } from "react-hot-toast";
import { Vortex } from "react-loader-spinner";

const BuyNowNftBox = () => {
  const navigate = useNavigate()
  const [plan, setplan] = useState({});
  let { nftBoxValue } = useParams();
  const [userdata, setuserdata] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalLoad, setShowModalLoad] = useState(false);
  const [currentBNBBalance, setcurrentBNBBalance] = useState("0.000000");
  const [transactionError, settransactionError] = useState("");
  const [buyTransactionHash, setbuyTransactionHash] = useState("");
  const [connectWalletAddress, setConnectWalletAddress] = useState("");
  const [process, setprocess] = useState("");
  const [MintingTimer, setMintingTimer] = useState("");
  const [rewardCategoriesDetails, setRewardCategoriesDetails] = useState([])
  const [nftBoxDetails, setNftBoxDetails] = useState([])

  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
      Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
    );

    useEffect(() => {
      if (nftBoxValue == 0) {
        navigate(`${config.baseUrl}nftbox`)
      } else {
        getDataForNftDetails()
      }
    }, [])

  useEffect(() => {
    setTimeout(() => {
      if (loginData.id) {
        getStepMintProfile();
        getBNBBalance();
      }
    }, 500);
  }, []);

  const getBNBBalance = async () => {
    if (window.ethereum) {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      setConnectWalletAddress(accounts[0]);
      let web3 = new Web3(window.ethereum);
      let getBalace = (await web3.eth.getBalance(accounts[0])) / 10 ** 18;
      let currentBal = parseFloat(getBalace).toFixed(6);
      setcurrentBNBBalance(currentBal);
    }
  };

 
  const redirect = () => {
    setShowModalLoad(false);
    window.location.reload();
  };


  const getStepMintProfile = async () => {
    let res = await UserProfile();
    if (res.success) {
      setuserdata(res.data);
    } else {
      setuserdata([]);
    }
  };

  const approve = async (
    abi,
    contractAddress,
    amount,
    toAddress,
    from_address
  ) => {

    // setprocess("Your approval is processing");
    amount += 500;

    let web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(abi, contractAddress);
    let allowance = await contract.methods
      .allowance(from_address, toAddress)
      .call();

    allowance = parseFloat((parseInt(allowance) / 10 ** 18).toFixed(6));
    console.log({ allowance, amount });
    if (allowance >= amount) {
      return true;
    }
    amount = web3.utils.toWei(amount.toString(), "ether");
    console.log({ amount });
    try {
      let approve = await contract.methods.approve(toAddress, amount);
      let encoded_tx = approve.encodeABI();
      let gasPrice = await web3.eth.getGasPrice();

      //fees for approval & buyPlan trx
      let getBalace = await web3.eth.getBalance(from_address);
      let fees = ((47000 + 285000) * parseInt(gasPrice)) / 10 ** 18;
      let currentBal = parseFloat((parseInt(getBalace) / 10 ** 18).toFixed(6));
      if (fees > currentBal) {
        toast.error(
          `Insufficient gas fee for transaction, Minimum ${parseFloat(
            fees
          ).toFixed(6)} BNB balanace required for transaction`
        );
        setShowModal(false);
        return false;
      }

      let gasLimit = await web3.eth.estimateGas({
        gasPrice: web3.utils.toHex(gasPrice),
        to: contractAddress,
        from: from_address,
        data: encoded_tx,
      });
      let trx = await web3.eth.sendTransaction({
        gasPrice: web3.utils.toHex(gasPrice),
        gas: web3.utils.toHex(gasLimit),
        to: contractAddress,
        from: from_address,
        data: encoded_tx,
      });
      if (trx.transactionHash) {
        console.log("trx.transactionHash", trx.transactionHash);
        return true;
      } else {
        toast.error("User Reject Approval");
        setShowModal(false);
        return false;
      }
    } catch (err) {
      if (err.code == 4001) {
        toast.error("User Reject Approval");
      } else if (err.code == -32603) {
        toast.error("Insufficient Allowance");
      } else {
        toast.error(err.message);
      }
      setShowModal(false);
      return false;
    }
  };

  const handleBuyNFTBox = async () => {
    if (!nftBoxValue) {
      toast.error('Please Nft Box Value')
      return
    }
    try {
      if (loginData.bnb_address == null) {
        // handleWalleteVerificationModal(e);
      } else {
        setShowModal(true);
        // setprocess("Your Transaction is processing");
        // if (!loginData.id) {
        //   setShowModal(false);
        //   toast.error(
        //     "You need to connect with your Meta mask Wallet before purchase"
        //   );
        //   return;
        // }
        if (window.ethereum) {
          let web3 = new Web3(window.ethereum);

          let chainId;
          try {
            chainId = await web3.currentProvider.chainId;
            if (!chainId) {
              chainId = await web3.currentProvider.getChainId();
            }
          } catch (error) {
            window.location.reload();
            return false;
          }
          if (
            chainId != config.chainId &&
            web3.utils.toHex(parseInt(chainId)) != config.chainId
          ) {
            toast.error(`Please select BNB smartchain!!`);
            setShowModal(false);
            return false;
          }
          let MrmintContractCall = new web3.eth.Contract(
            config.mrmintContractAbi,
            config.contractAddressForRecharge
          );

          const accounts = await window.ethereum.request({
            method: "eth_requestAccounts",
          });
          let from_address = accounts[0];
          if (loginData.bnb_address && loginData.bnb_address.toLowerCase() != from_address.toLowerCase()) {
            toast.error(`Please connect with registered wallet`);
            setShowModal(false);
            return false;
          }
          let balanceOf = await MrmintContractCall.methods
            .balanceOf(accounts[0])
            .call();
          let contractWallet = new web3.eth.Contract(
            config.nftBoxContractAbi,
            config.nftBoxPurchaseContractAddress
          );
          let usdtValue = nftBoxValue;
          let usdt = Web3.utils.toWei(usdtValue.toString(), "ether");
          let getpurchaseStepByToken = await contractWallet.methods
            .getUsdtInMnt(usdt.toString())
            .call();

          let updateAmountToken = parseFloat(
            (parseInt(getpurchaseStepByToken) / 10 ** 18 + 5).toFixed(6)
          );
          // setPlanPrice(updateAmountToken);
          balanceOf = parseFloat((parseInt(balanceOf) / 10 ** 18).toFixed(6));
          if (!loginData.id) {
            setShowModal(false);
            toast.error(
              "You need to connect with your Meta mask Wallet before purchase"
            );
            return;
          }
          if (updateAmountToken > balanceOf) {
            toast.error(`Insufficient Balance`);
            setShowModal(false);
            return;
          }
          let approval = await approve(
            config.mrmintContractAbi,
            config.contractAddressForRecharge,
            updateAmountToken,
            config.nftBoxPurchaseContractAddress,
            from_address
          );

          if (approval) {
            try {
              setprocess("Your transaction is processing");
              let purchaseStepByToken = await contractWallet.methods.addInvestment(
                nftBoxValue/100
              );

              let encoded_tx = purchaseStepByToken.encodeABI();
              let gasPrice = await web3.eth.getGasPrice();
              gasPrice = parseInt(gasPrice) + 5 * 10 ** 9;

              //fees for buyPlan trx
              let getBalace = await web3.eth.getBalance(from_address);
              let fees = (285000 * parseInt(gasPrice)) / 10 ** 18;
              let currentBal = parseFloat(
                (parseInt(getBalace) / 10 ** 18).toFixed(6)
              );
              if (fees > currentBal) {
                toast.error(
                  `Insufficient gas fee for transaction, Minimum ${parseFloat(
                    fees
                  ).toFixed(6)} BNB balanace required for transaction`
                );
                setShowModal(false);
                return false;
              }

              let gasLimit = await web3.eth.estimateGas({
                gasPrice: web3.utils.toHex(gasPrice),
                to: config.nftBoxPurchaseContractAddress,
                from: from_address,
                data: encoded_tx,
              });

              let trx = await web3.eth.sendTransaction({
                gasPrice: web3.utils.toHex(gasPrice),
                gas: web3.utils.toHex(gasLimit),
                to: config.nftBoxPurchaseContractAddress,
                from: from_address,
                data: encoded_tx,
              });
              console.log("trxxxxx", trx);
              if (trx) {
                setbuyTransactionHash(trx.transactionHash);
                toast.success("Transaction has been created successfully");
                setTimeout(() => {
                  setShowModal(true);
                  let timer = 120;
                  setInterval(() => {
                    timer -= 1;
                    setMintingTimer(timer);
                    if (timer <= 0) {

                      window.location.reload();
                    }
                  }, 1500);
                }, 1000);
              }
            } catch (err) {
              setShowModal(false);
              if (err.code == -32603) {
                toast.error("Insufficent Allowance : " + err.message);
              }
              if (err.code == -32000) {
                toast.error("Gas Required Exceeds : " + err.message);
              }
              if (err.message.toString().split("insufficient funds")[1]) {
                settransactionError("Transaction reverted : " + err.message);
                toast.error("Transaction reverted : " + err.message);
              } else {
                if (err.toString().split("execution reverted:")[1]) {
                  toast.error(
                    "Transaction reverted : " +
                    err
                      .toString()
                      .split("execution reverted:")[1]
                      .toString()
                      .split("{")[0]
                  );
                  settransactionError(
                    "Transaction reverted : " +
                    err
                      .toString()
                      .split("execution reverted:")[1]
                      .toString()
                      .split("{")[0]
                  );
                } else {
                  settransactionError(err.message);
                  toast.error(err.message);
                }
              }
              setShowModal(false);
              return false;
            }
          }
          setShowModal(false);
        } else {
          toast.error("Please use Dapp browser!!");
          setShowModal(false);
        }
      }
    } catch (error) {
      console.log(error);
      switch (error.code) {
        case 4001:
          toast.error("User Rejected");
          break;
        case -32002:
          toast.error(
            "Request Already Processing, Please check your Meta Mask wallet"
          );
          break;
        case "ERR_NETWORK":
          toast.error("We're experiencing technical difficulties.");
          break;
        default:
          toast.error(error.message);
          break;
      }
      setShowModal(false);
    }
  };
  

  const getDataForNftDetails = async () => {
    try {
      const res = await getDataForNftDetailsAction(nftBoxValue)
      if (res.success) {
        setRewardCategoriesDetails(res.data.reward_categories)
        setNftBoxDetails(res.data.box_purchase_details)
      }
    } catch (error) {
      console.log(error);

    }
  }

  return (
    <>
      <Toaster />
      <section className="position-relative overflow-hidden nftdetail">
        <div className="leftshadow">
          <img src="assets/images/blueleft.png" />
        </div>
        <Container>
          <Row>
            <Col lg={12}>
              <div>
                <Fade right>
                  <h1 className="text-white">NFTs Box Details</h1>
                </Fade>
              </div>
            </Col>
            <Col lg={12}>
              <div className="card card-view border-0 p-4 position-relative overflow-hidden">
                <div>
                  <img
                    src="assets/images/logo-shap3.png"
                    className="botton-left"
                    style={{zIndex:-1}}
                  />
                </div>
                <Row className="gy-3 ">
          <Col>
            <div className="nftbox-card3 d-flex flex-column justify-content-center text-white px-4 pt-4 py-3">
              <Row>
                <Col>
                  <h3 style={{ fontWeight: 700 }}>NFT Box</h3>
                  <p className="nft-card-no mb-1">Total Subscription</p>
                
                </Col>
                <Col className="text-end mt-1">
                <h5 style={{ fontWeight: 600 }}>${nftBoxValue}</h5>
                {/* <p className="nft-card-no mb-1">2584.55 MNT</p> */}
                </Col>

              </Row>
              {/* <img src="assets/images/nftbackground.png" className="position-absolute" style={{opacity:0.4}} alt="" /> */}
              <div className="w-100 d-flex flex-row justify-content-center gap-4">
                <img src="assets/images/nftbox2.svg" alt="" />
                <img
                  className="glow-img"
                  src="assets/images/nftbox1.svg"
                  alt=""
                />
                <img src="assets/images/nftbox2.svg" alt="" />
              </div>
            </div>
          </Col>
          <Col
            style={{ border: "1px solid #ffffff50", borderRadius: 10 }}
            className="d-flex flex-column align-items-center justify-content-center py-3 mx-2"
          >
            <Row className="gy-3">
              <Col lg={12}>
                <div className="nft-details-column d-flex justify-content-between p-2 highlight">
                  <p className="mb-0">Category</p>
                  <p className="mb-0">{nftBoxDetails.category_name}</p>
                </div>
              </Col>
              <Col lg={12}>
                <div className="nft-details-column d-flex justify-content-between p-2">
                  <p className="mb-0">Valid Till</p>
                  <p className="mb-0">{nftBoxDetails.validity}</p>
                </div>
              </Col>
              <Col lg={12}>
                <div className="nft-details-column d-flex justify-content-between p-2">
                  <p className="mb-0">Per Day Reward</p>
                  <p className="mb-0">{nftBoxDetails.reward_percent}</p>
                </div>
              </Col>
              <Col lg={12}>
                <div className="nft-details-column d-flex justify-content-between p-2">
                  <p className="mb-0">Expire On</p>
                  <p className="mb-0">{nftBoxDetails.expiry_date}</p>
                </div>
              </Col>
              <Col
                lg={12}
                className=" d-flex px-0 align-items-center justify-content-center"
              >
                <Row className="gy-2 px-0  w-100">
                  <Col lg={12} className="d-flex justify-content-center" onClick={handleBuyNFTBox}>
                    <button className="nftbox-submit w-100">
                      {" "}
                      Buy Now

                    </button>
                  </Col>

                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
              </div>
            </Col>

         
            {/* --------------------- */}
            <Modal
              show={showModal}
              className="walker_detail"
              centered
              size="l"
              backdrop="static"
            >
              <Modal.Body>
                <Row>
                  <Vortex
                    visible={showModal == true ? true : false}
                    height="80"
                    width="80"
                    ariaLabel="vortex-loading"
                    wrapperStyle={{}}
                    wrapperClass="vortex-wrapper"
                    colors={[
                      "#6610f2;",
                      "#6f42c1",
                      "blue",
                      "#300d39",
                      "#212529",
                      "purple",
                    ]}
                  />
                  <div className="" style={{ display: "grid" }}>
                    <p style={{ margin: "auto" }}>
                      Please wait.....
                      {MintingTimer && `${MintingTimer} seconds`}{" "}
                    </p>
                    <p style={{ margin: "auto" }}>{process}</p>
                  </div>
                </Row>
              </Modal.Body>
            </Modal>
            {/* ----------------- */}

            {/* --------------------- */}
            <Modal
              show={showModalLoad}
              className="walker_detail"
              centered
              size="l"
              backdrop="static"
            >
              <Modal.Body>
                <Row>
                  <div className="" style={{ display: "grid" }}>
                    <p style={{ margin: "auto" }}>
                      Your transaction is in Progress
                    </p>
                    <p style={{ margin: "auto" }}>
                      It will take some time to reflect to your account
                    </p>
                    <p style={{ margin: "auto" }}>
                      Your can check your transaction by visiting{" "}
                      <a
                        href={`${config.bsc_url}/${buyTransactionHash}`}
                        target="_blank"
                      >
                        {buyTransactionHash.slice(0, 4) +
                          "..." +
                          buyTransactionHash.slice(-4)}
                      </a>
                      
                    </p>
                  </div>
                </Row>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-center">
                <Button variant="secondary" onClick={redirect}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
            {/* ----------------- */}
          </Row>
        </Container>
      </section>
    </>
  );
};
export default BuyNowNftBox;
